<template>
    <div id="SupplyChainCarouselTrashcar" class="CompanyCarousel">
        <div class="mid fadeInUp">
            <ul class="circle-list">
                <li>
                    淨灘垃圾清運與相關問題聯繫窗口請參考
                    <a
                        class="bold underline"
                        href="https://ecolife2.moenv.gov.tw/Coastal/SeaApply/Contacts"
                        target="_blank"
                    >
                        環境部資源循環署海岸淨灘系統
                    </a>
                </li>
                <li>
                    淨灘收集之寶特瓶、漁網及保麗龍想循環利用製成海廢循環產品，有下列情形可洽詢當地環保局
                </li>
                <ul class="square-list">
                    <li>
                        <h4>有暫存海廢需求者</h4>
                        <ul class="f12">
                            <li
                                v-for="item in trashCar.tempStorage"
                                :key="item[0]"
                            >
                                <template
                                    v-for="(text, idx) in item"
                                    :key="idx"
                                >
                                    <p v-if="idx == 0" class="bold">
                                        {{ text }}
                                    </p>
                                    <p v-else>{{ text }}</p>
                                </template>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h4>與環保局合作製作海廢循環產品</h4>
                        <ul class="f12">
                            <li
                                v-for="item in trashCar.coProduct"
                                :key="item[0]"
                            >
                                <template
                                    v-for="(text, idx) in item"
                                    :key="idx"
                                >
                                    <p v-if="idx == 0" class="bold">
                                        {{ text }}
                                    </p>
                                    <p v-else>{{ text }}</p>
                                </template>
                            </li>
                        </ul>
                    </li>
                </ul>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'SupplyChainCarouselTrashcar',
}
</script>

<script setup>
import trashCar from '../../data/getSupplyChainTrashCar.js'
</script>
<style lang="scss" scoped>
.CompanyCarousel {
    display: none;
    height: 0;
    background-color: $grayF;
    overflow: hidden;
    transition: 0.3s;
}

.mid {
    color: $gray6;
    width: 80%;
    max-width: 600px;
    margin: 50px auto;
    ul.f12 {
        line-height: 1.3em;
        li {
            margin: 0.6em 0;
        }
    }
}
</style>
